import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconFilledCheck } from 'images/icon-filled-check.svg';

interface LoginLinkProps {
  extraClassName?: string;
}

const LoginLink = ({ extraClassName }: LoginLinkProps) => {
  const { t } = useTranslation(['auth']);
  const navigate = useNavigate();

  const goToBeneficiarySite = () => {
    navigate('/login');
  };

  return (
    <div
      className={`card t-p-3 t-flex t-border-beta-200 t-cursor-pointer ${extraClassName}`}
      onClick={goToBeneficiarySite}
    >
      <IconFilledCheck className="t-text-alpha-600" />
      <p className="typo-epsilon t-ml-3 t-text-alpha-600">
        {t('auth:login_link_text')}
      </p>
    </div>
  );
};

export default LoginLink;
